import {

} from "@/request/api";

export default function OurMap() {
    this.markers = []; //飞机核心点数组
    this.stationMarkers = []; //基站
    this.GroundBaseMarkers = []; //静态基站

    this.Labels = []; //标牌
    this.adsbMap = null; //图层组
    this.predictLinePolys = []; //预测线
    this.locusLinePolys = []; //轨迹线
    this.wakeLinePolys = []; //尾迹线
    this.followPolys = []; //关注


    //测距开关
    this.openRanging = false;

    /** 是否开始滑动*/
    this.isStartMove = false;
    /** 滑动是否结束*/
    this.isEndMove = false;

    this.num = 0; //计数器

    this.calculatDistanceLine; //绘制的实例
    this.calculatDistanceLines = []; //折线实例数组
    this.calculatDistanceMark; //距离标签
    this.calculatDistanceMarks = []; //距离标签实例数组

    this.MarkerPoints = []; //测距点实例
    this.points = []; //所有的测距点
    this.latePoint = null; //最近点击的点

    this.tagHeight = true;
    this.tagSn = true;
    this.tagSp = true;
    this.tagCompany = true;
    this.tagHeightChage = true;

}

//初始化传值
OurMap.prototype.initOurMap = function({
    adsbMap,
    showPlan,
    aircraftInfos,
    vm
}) {
    this.adsbMap = adsbMap;
    this.aircraftInfos = aircraftInfos;
    this.showPlan = showPlan;
    this.$vm = vm;
}


//开启测距
OurMap.prototype.openRangingFun = function(openRanging) {
    this.openRanging = openRanging; //测距开启
}

/**
 * 创建静态基站
 */

OurMap.prototype.createAllGroundBase = async function() {
    var ourMap = this;

    let res = await ourMap.$vm.$axios.get(process.env.BASE_URL + "/static/json/CustomGroundBase.json");

    let GroundBaseArr = res.data;
    GroundBaseArr.forEach((GroundBase) => {
        let marker = L.marker(
                [GroundBase.lat, GroundBase.lng], {
                    icon: L.icon({
                        iconUrl: require("../../../public/image/baseRadar.png"),
                        iconSize: [20, 20],
                        iconAnchor: [15, 15],
                    }),
                    id: GroundBase.id,
                    pane: "adsb_base",
                }
            ).bindPopup(`
            <p style="text-align: center;">${GroundBase.name}</p>
            <p style="text-align: center;">纬度:${ToDegrees(GroundBase.lat)[0] + "°" + ToDegrees(GroundBase.lat)[1] + "′" + ToDegrees(GroundBase.lat)[2] + "′′" + "E"
            }</p>
            <p style="text-align: center;">经度:${ToDegrees(GroundBase.lng)[0] + "°" + ToDegrees(GroundBase.lng)[1] + "′" + ToDegrees(GroundBase.lng)[2] + "′′" + "N"}</p>
            `, {
                className: 'DistancePopup',
                pane: 'util',
                closeButton: false,
                offset: [0, 100]
            })
            .addTo(ourMap.adsbMap.stationGroup);


        marker.icao = GroundBase.id;
        ourMap.GroundBaseMarkers.push(marker);

    })
}



/**
 * 创建飞机
 * @param aircraftInfo
 */

OurMap.prototype.createOneMarker = function(aircraftInfo) {
    var ourMap = this;

    var latlng = L.latLng(aircraftInfo.alLatitude, aircraftInfo.alLongitude);

    //初始化每一个点
    var marker = L.marker(
            latlng, {
                icon: L.icon({
                    iconUrl: process.env.BASE_URL + '/image/normalPlane.png',
                    iconSize: [20, 20],
                    iconAnchor: [15, 15],
                    tooltipAnchor: [20, 0],
                }),
                rotationAngle: aircraftInfo.aircraftcategory === 'FREE_BALLOON' ? 0 : Number(aircraftInfo.airVelocityInfo.avBiasMagneticNorth),
                rotationOrigin: "center center",
                pane: "adsb_air",
            }
        )
        .addTo(ourMap.adsbMap.iconGroup);

    marker.icao = aircraftInfo.icao;
    marker.callsign = aircraftInfo.callsign;
    marker.aircraftInfo = aircraftInfo;

    marker.on("click", (e) => {
        console.log(e);
        if (ourMap.openRanging) {
            return
        }

        //点击飞机
        if (aircraftInfo.currentHeight) {
            //点击当前高度飞机
            if (aircraftInfo.isShowLabel) {
                if (aircraftInfo.partOfGeneralCompany) {
                    // ourMap.showPlan(aircraftInfo);
                } else {
                    aircraftInfo.isShowLabel = false;
                    aircraftInfo.disappearLabel(aircraftInfo.icao);
                }
            } else {
                aircraftInfo.isShowLabel = true;
                ourMap.createAircraftLabel(aircraftInfo);
            }
        }

    });



    marker.on('contextmenu', (e) => {
        //右键飞机
        if (ourMap.openRanging) {
            return;
        }

        console.log(1);
        if (aircraftInfo.currentHeight) {
            if (aircraftInfo.isShowLabel) {
                if (aircraftInfo.partOfGeneralCompany) {
                    ourMap.$vm.showFunMeunBar(aircraftInfo);
                }
            }
        }
    });


    /**
     * 开始滑动 左键 选中（点 地图） 右键结束
     */

    marker.on('contextmenu', function(event) {
        if (ourMap.openRanging) {

            // if (!ourMap.isStartMove);
            if (ourMap.isStartMove) {
                ourMap.num++;
            } else {
                ourMap.num = 0;
            }

            var postion = {
                index: ourMap.num,
                hasIcao: true,
                icao: aircraftInfo.icao,
                la: aircraftInfo.alLatitude,
                lo: aircraftInfo.alLongitude,
            };

            if (ourMap.latePoint) {
                if (ourMap.latePoint.index < postion.index) {
                    ourMap.showDistance([ourMap.latePoint, postion]);
                    ourMap.addRangePolyline([ourMap.latePoint, postion]);
                }
            }

            ourMap.points.push(postion);

            ourMap.latePoint = {...postion };
            ourMap.isStartMove = true;

            var circleMarker = L.circleMarker(
                [event.latlng.lat, event.latlng.lng], {
                    radius: 5,
                    color: "#90ee90",
                    opacity: 1,
                }
            ).addTo(map);
            circleMarker.hasIcao = true;
            circleMarker.icao = aircraftInfo.icao;
            ourMap.MarkerPoints.push(circleMarker);
        }
    });
    marker.on('click', function(event) {
        if (ourMap.openRanging) {
            if (!ourMap.isStartMove) {
                return
            }
            if (ourMap.isEndMove) {
                ourMap.num++;
                var postion = {
                    index: ourMap.num,
                    hasIcao: true,
                    icao: aircraftInfo.icao,
                    la: aircraftInfo.alLatitude,
                    lo: aircraftInfo.alLongitude,
                };

                ourMap.showDistance([ourMap.latePoint, postion]);
                ourMap.addRangePolyline([ourMap.latePoint, postion]);
                ourMap.points.push(postion);
            }
            ourMap.isStartMove = false;
            ourMap.isEndMove = false;
            ourMap.latePoint = null;

            var circleMarker = L.circleMarker(
                [event.latlng.lat, event.latlng.lng], {
                    radius: 5,
                    color: "#90ee90",
                    opacity: 1,
                }
            ).addTo(map);
            circleMarker.hasIcao = true;
            circleMarker.icao = aircraftInfo.icao;
            ourMap.MarkerPoints.push(circleMarker);
        }
    });

    ourMap.markers.push(marker);

    //筛选机制
    //初始化设置高度
    ourMap.setHeightMarker(marker, aircraftInfo);

    //初始化设置类型
    ourMap.setTypeMarker(marker, aircraftInfo, aircraftInfo.watchAir);

}


/**
 * 高亮当前高度飞机,改变高度显示隐藏
 * @param aircraftInfo
 */
OurMap.prototype.setHeightMarker = function(marker, aircraftInfo) {
    var ourMap = this;

    if (!marker) {
        return
    }

    if (aircraftInfo.currentHeight) {
        let Label1 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 1);
        let Label2 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 2);
        if (Label1 && Label2) {
            Label1.setStyle({
                weight: 1,
            });
            Label2._icon.style.display = '';
        }

        var icon = ourMap.getMarkerIcon(aircraftInfo);
        marker.setIcon(icon);

    } else {
        let Label1 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 1);
        let Label2 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 2);

        if (Label1 && Label2) {
            Label1.setStyle({
                weight: 0,
            });
            Label2._icon.style.display = 'none';
        }

        var icon = ourMap.initMarkerIcon(aircraftInfo);
        marker.setIcon(icon);
    }
}


/**
 * 设置分类
 * @param airType 
 * @param aircraftInfo
 */
OurMap.prototype.setTypeMarker = function(marker, aircraftInfo, airType) {

    var ourMap = this;

    if (!marker) {
        return
    }

    //高度筛选
    if (!aircraftInfo.currentHeight) {
        return
    }

    let Label1 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 1);
    let Label2 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 2);

    if (Label1 && Label2) {
        Label1.setStyle({
            weight: 0,
        });
        Label2._icon.style.display = 'none';
    }

    var icon = ourMap.initMarkerIcon(aircraftInfo);
    marker.setIcon(icon);

    if (airType.General) {

        if (aircraftInfo.aircraftcategory === 'AIRCRAFT' || aircraftInfo.aircraftcategory === 'ROTORCRAFT' ||
            aircraftInfo.aircraftcategory === 'HELICOPTER' || aircraftInfo.aircraftcategory === 'ROTATION_ROTORCRAFT' ||
            aircraftInfo.aircraftcategory === 'AIRSHIP' || aircraftInfo.aircraftcategory === 'PRIMARY_AIRCRAFT'
        ) {

            let Label1 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 1);
            let Label2 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 2);
            if (Label1 && Label2) {
                Label1.setStyle({
                    weight: 1,
                });
                Label2._icon.style.display = '';
            }
            var icon = ourMap.getMarkerIcon(aircraftInfo);
            marker.setIcon(icon);

        }

    }


    if (airType.Transport) {
        if (aircraftInfo.aircraftcategory === '') {
            let Label1 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 1);
            let Label2 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 2);
            if (Label1 && Label2) {
                Label1.setStyle({
                    weight: 1,
                });
                Label2._icon.style.display = '';
            }
            var icon = ourMap.getMarkerIcon(aircraftInfo);
            marker.setIcon(icon);

        }
    }

    if (airType.Terminal) {
        if (aircraftInfo.aircraftcategory === 'FREE_BALLOON' || aircraftInfo.aircraftcategory === 'GLIDER') {
            let Label1 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 1);
            let Label2 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 2);
            if (Label1 && Label2) {
                Label1.setStyle({
                    weight: 1,
                });
                Label2._icon.style.display = '';
            }
            var icon = ourMap.getMarkerIcon(aircraftInfo);
            marker.setIcon(icon);

        }
    }
    if (airType.UAV) {
        if (aircraftInfo.aircraftcategory === 'UNMANNEDAV') {
            let Label1 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 1);
            let Label2 = ourMap.getOneLabelByIcao(aircraftInfo.icao, 2);
            if (Label1 && Label2) {
                Label1.setStyle({
                    weight: 1,
                });
                Label2._icon.style.display = '';
            }
            var icon = ourMap.getMarkerIcon(aircraftInfo);
            marker.setIcon(icon);

        }
    }
}


/**
 * 创建地面站并更新
 * @param aircraftInfo
 */
OurMap.prototype.createOneStation = function(aircraftInfo) {
    var ourMap = this;


    var index = this.getOneKeyStationIndex(aircraftInfo.icao);
    if (index == -1) { //没有就添加

        let marker = L.marker(
                [aircraftInfo.alLatitude, aircraftInfo.alLongitude], {
                    icon: L.icon({
                        iconUrl: process.env.BASE_URL + "/image/baseRadar.png",
                        iconSize: [20, 20],
                        iconAnchor: [15, 15],
                    }),
                    id: aircraftInfo.icao,
                    pane: "adsb_base",
                }
            )
            .addTo(ourMap.adsbMap.stationGroup);

        marker.icao = aircraftInfo.icao;
        ourMap.stationMarkers.push(marker);
    } else {
        index.setLatLng(L.latLng(
            aircraftInfo.alLatitude,
            aircraftInfo.alLongitude
        ))
    }
}

/**
 * 清除地面站
 * @param aircraftInfo
 */
OurMap.prototype.clearOneStation = function(aircraftInfo) {
    var ourMap = this;
    ourMap.adsbMap.stationGroup.clearLayers();
}



/**
 * 创建标牌
 * @param aircraftInfo
 */
OurMap.prototype.createAircraftLabel = function(aircraftInfo) {
    var ourMap = this;
    let latlon = ourMap.fixed(aircraftInfo, aircraftInfo.dargxy);

    aircraftInfo.hasLabel = true; //是否有标牌

    if (aircraftInfo.dargxy.x > 0) {
        let latlng = ourMap.correctOffsetDargxy(aircraftInfo);
        var polyline = L.polyline(
            [
                [
                    aircraftInfo.alLatitude,
                    aircraftInfo.alLongitude,
                ],
                latlng,
            ], { color: "#76b5d7", id: aircraftInfo.icao, weight: 1 }
        ).addTo(ourMap.adsbMap.iconGroup);

    } else {
        let latlng = ourMap.correctOffsetDargxy(aircraftInfo);
        // let latlng = ourMap.fixed(aircraftInfo, { x: aircraftInfo.dargxy.x, y: aircraftInfo.dargxy.y });
        var polyline = L.polyline(
            [
                [
                    aircraftInfo.alLatitude,
                    aircraftInfo.alLongitude,
                ],
                latlng,
            ], { color: "#76b5d7", id: aircraftInfo.icao, weight: 1 }
        ).addTo(ourMap.adsbMap.iconGroup);
    }


    var marketDiv = L.marker(latlon, {
        draggable: true,
        icon: aircraftInfo.partOfGeneralCompany ? L.divIcon({
            className: "myAdsbTooltip",
            html: ourMap.initLabelHtmlStr(aircraftInfo, false),
            iconAnchor: [25, 25]
        }) : L.divIcon({
            className: "ohterAdsbTooltip",
            html: ourMap.initLabelHtmlStr(aircraftInfo, false),
            iconAnchor: [25, 25]
        }),
        pane: "adsb_air",
        rotationOrigin: "center center",
    }).addTo(ourMap.adsbMap.iconGroup);



    // var market = L.circle(latlon, {
    //     radius: 20000,

    // }).
    // bindTooltip(aircraftInfo.callsign, {
    //     permanent: true,
    // }).addTo(map);


    polyline.type = 1;
    marketDiv.type = 2;
    polyline.icao = aircraftInfo.icao;
    marketDiv.icao = aircraftInfo.icao;
    polyline.aircraftInfo = aircraftInfo;
    marketDiv.aircraftInfo = aircraftInfo;
    marketDiv.divClick = false; //是否显示全标牌

    ourMap.Labels.push(polyline);
    ourMap.Labels.push(marketDiv);

    marketDiv.on('contextmenu', (e) => {
        //右键飞机

        if (aircraftInfo.currentHeight) {
            if (aircraftInfo.isShowLabel) {
                if (aircraftInfo.partOfGeneralCompany) {
                    ourMap.$vm.showFunMeunBar(aircraftInfo);
                }
            }
        }
    });


    marketDiv.on("click", (e) => {
        let marketDiv = e.target;
        let allMarketDiv = ourMap.getAllLabel(2);


        if (marketDiv.divClick) {
            marketDiv.divClick = false;
            marketDiv._icon.innerHTML = ourMap.initLabelHtmlStr(marketDiv.aircraftInfo, marketDiv);
            return
        }


        allMarketDiv.forEach((MarketDiv) => {
            MarketDiv.divClick = false;
            MarketDiv._icon.innerHTML = ourMap.initLabelHtmlStr(MarketDiv.aircraftInfo, MarketDiv);
        });


        marketDiv.divClick = true;
        marketDiv._icon.innerHTML = ourMap.initLabelHtmlStr(marketDiv.aircraftInfo, marketDiv);

    });

    marketDiv.on("dragstart", (e) => {});

    marketDiv.on("drag", (e) => {
        aircraftInfo.dargxy = this.setdargxy(
            aircraftInfo,
            e.target._latlng
        );

        let latlng = ourMap.correctOffsetDargxy(aircraftInfo);

        polyline.setLatLngs([
            [
                aircraftInfo.alLatitude,
                aircraftInfo.alLongitude,
            ],
            latlng,
        ]);

        e.target.setLatLng(e.target._latlng);
    });

    marketDiv.on("dragend", (e) => {
        aircraftInfo.dargxy = this.setdargxy(
            aircraftInfo,
            e.target._latlng
        );

        let latlng = ourMap.correctOffsetDargxy(aircraftInfo);

        polyline.setLatLngs([
            [
                aircraftInfo.alLatitude,
                aircraftInfo.alLongitude,
            ],
            latlng,
        ]);

        e.target.setLatLng(e.target._latlng);
    });


}

/**
 * 标牌线纠偏
 * @param  aircraftInfo
 * @returns latlng
 */

OurMap.prototype.correctOffsetDargxy = function(aircraftInfo) {
    let ourMap = this;
    let latlng;
    if (aircraftInfo.dargxy.x > 0) {

        if (aircraftInfo.dargxy.y > 0) { //第四象限

            latlng = ourMap.fixed(aircraftInfo, { x: aircraftInfo.dargxy.x - 20, y: aircraftInfo.dargxy.y - 10 });
        } else { //第一象限
            latlng = ourMap.fixed(aircraftInfo, { x: aircraftInfo.dargxy.x - 20, y: aircraftInfo.dargxy.y + 25 });
        }

    } else if (aircraftInfo.dargxy.x == 0) {
        if (aircraftInfo.dargxy.y > 0) { //下
            latlng = ourMap.fixed(aircraftInfo, { x: aircraftInfo.dargxy.x, y: aircraftInfo.dargxy.y - 30 });
        } else { //上
            latlng = ourMap.fixed(aircraftInfo, { x: aircraftInfo.dargxy.x + 20, y: aircraftInfo.dargxy.y + 30 });
        }
    } else {
        if (aircraftInfo.dargxy.y > 0) { //第三象限
            latlng = ourMap.fixed(aircraftInfo, { x: aircraftInfo.dargxy.x + 25, y: aircraftInfo.dargxy.y - 10 });
        } else { //第二象限
            latlng = ourMap.fixed(aircraftInfo, { x: aircraftInfo.dargxy.x + 20, y: aircraftInfo.dargxy.y + 25 });
        }
    }


    return latlng;
}

/**
 * 设置标牌位置 (地图缩放时使用)
 * @returns
 */
OurMap.prototype.setLabelPosition = function() {
    var ourMap = this;

    ourMap.Labels.forEach((item, index) => {
        if (item.type === 1) {

            let latlng = ourMap.correctOffsetDargxy(item.aircraftInfo);

            item.setLatLngs([
                [
                    item.aircraftInfo.alLatitude,
                    item.aircraftInfo.alLongitude,
                ],
                latlng,
            ]);
        }
        if (item.type === 2) {
            let latlon = ourMap.fixed(item.aircraftInfo, item.aircraftInfo.dargxy);
            item.setLatLng(latlon);
        }
    });

}


/**
 * 转换
 * @param aircraftInfo
 * @param xy
 */
OurMap.prototype.setdargxy = function(aircraftInfo, latlng) {
    var pixel1 = map.latLngToContainerPoint([
        aircraftInfo.alLatitude,
        aircraftInfo.alLongitude,
    ]);

    var pixel2 = map.latLngToContainerPoint([latlng.lat, latlng.lng]);

    let xy = { x: pixel2.x - pixel1.x, y: pixel2.y - pixel1.y };
    return xy;
};

/**
 * 转换
 * @param aircraftInfo
 * @param xy
 */
OurMap.prototype.fixed = function(aircraftInfo, xy) {
    var pixel = map.latLngToContainerPoint([
        aircraftInfo.alLatitude,
        aircraftInfo.alLongitude,
    ]);

    var v = { x: pixel.x + xy.x, y: pixel.y + xy.y }; //标牌避让的像素点在这里

    return map.containerPointToLatLng(v); //拖拽点的坐标，默认偏5
};


/**
 * 转换
 * @param aircraftInfo
 * @param xy
 */
OurMap.prototype.getInitDargxy = function(aircraftInfo, xy) {
    var pixel = map.latLngToContainerPoint([
        aircraftInfo.alLatitude,
        aircraftInfo.alLongitude,
    ]);

    var v = { x: pixel.x + xy.x, y: pixel.y + xy.y }; //标牌避让的像素点在这里

    return v
};

/* 
 *动态基站数据
 */
OurMap.prototype.getOneKeyStationIndex = function(icao) {
    var ourMap = this;

    for (var i = 0; i < ourMap.stationMarkers.length; i++) {
        var marker = ourMap.stationMarkers[i];
        if (marker.icao == icao) {
            return marker;
        }
    }
    return -1;
}

/* 
 *获取静态基站数据
 */
OurMap.prototype.getOneKeyGroundBaseIndex = function(icao) {
    var ourMap = this;

    for (var i = 0; i < ourMap.GroundBaseMarkers.length; i++) {
        var marker = ourMap.GroundBaseMarkers[i];
        if (marker.icao == icao) {
            return marker;
        }
    }
    return -1;
}


/* 
 *隐藏静态基站数据
 */
OurMap.prototype.hideGroundBase = function() {
    var ourMap = this;
    for (var i = 0; i < ourMap.GroundBaseMarkers.length; i++) {
        var marker = ourMap.GroundBaseMarkers[i];
        marker.removeFrom(ourMap.adsbMap.stationGroup);
    }

}

/* 
 *显示静态基站数据
 */
OurMap.prototype.showGroundBase = function() {
        var ourMap = this;

        for (var i = 0; i < ourMap.GroundBaseMarkers.length; i++) {
            var marker = ourMap.GroundBaseMarkers[i];
            marker.addTo(ourMap.adsbMap.stationGroup);
        }

    }
    /**
     * 获取飞机图标 正常飞机
     * @param aircraftInfo
     * @returns
     */
OurMap.prototype.getMarkerIcon = function(aircraftInfo) {

    if (aircraftInfo.partOfGeneralCompany) {
        // 通航
        let my_icon;
        if (aircraftInfo.aircraftcategory === "AIRCRAFT") {
            //固定翼
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/whitePlane.png",
                iconSize: [25, 25],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else if (aircraftInfo.aircraftcategory === "ROTORCRAFT") {
            //旋翼机
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/whitePlane.png",
                iconSize: [25, 25],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else if (aircraftInfo.aircraftcategory === "HELICOPTER") {
            //直升机
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/helicopter0.png",
                iconSize: [35, 35],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else if (aircraftInfo.aircraftcategory === "FREE_BALLOON") {
            //气球
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/balloon.png",
                iconSize: [25, 25],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else if (aircraftInfo.aircraftcategory === "UNMANNEDAV") {
            //无人机
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/UAV1.png",
                iconSize: [25, 25],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else {

            if (aircraftInfo.icon === 'helicopter') {
                my_icon = L.icon({
                    iconUrl: process.env.BASE_URL + "/image/helicopter0.png",
                    iconSize: [30, 30],
                    iconAnchor: [15, 15],
                    tooltipAnchor: [20, 0],
                });
            } else {
                my_icon = L.icon({
                    iconUrl: process.env.BASE_URL + "/image/whitePlane.png",
                    iconSize: [25, 25],
                    iconAnchor: [15, 15],
                    tooltipAnchor: [20, 0],
                });
            }

        }
        return my_icon;
    } else {
        var other_icon = L.icon({
            iconUrl: process.env.BASE_URL + "/image/searchPlane.png",
            iconSize: [20, 20],
            iconAnchor: [15, 15],
            tooltipAnchor: [20, 0],
        });
        return other_icon
    }

}


/**
 * 关注飞机图标
 * @param aircraftInfo
 * @returns
 */
OurMap.prototype.getMarkerFollowIcon = function(aircraftInfo) {

    if (aircraftInfo.partOfGeneralCompany) {
        // 通航
        let my_icon;
        if (aircraftInfo.aircraftcategory === "AIRCRAFT") {
            //固定翼
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/whitePlane_a.png",
                iconSize: [25, 25],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else if (aircraftInfo.aircraftcategory === "ROTORCRAFT") {
            //旋翼机
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/whitePlane_a.png",
                iconSize: [25, 25],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else if (aircraftInfo.aircraftcategory === "HELICOPTER") {
            //直升机
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/helicopter0_a.png",
                iconSize: [35, 35],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else if (aircraftInfo.aircraftcategory === "FREE_BALLOON") {
            //气球
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/balloon_a.png",
                iconSize: [25, 25],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else if (aircraftInfo.aircraftcategory === "UNMANNEDAV") {
            //无人机
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/UAV1_a.png",
                iconSize: [25, 25],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else {
            if (aircraftInfo.icon === 'helicopter') {
                my_icon = L.icon({
                    iconUrl: process.env.BASE_URL + "/image/helicopter0_a.png",
                    iconSize: [30, 30],
                    iconAnchor: [15, 15],
                    tooltipAnchor: [20, 0],
                });
            } else {
                my_icon = L.icon({
                    iconUrl: process.env.BASE_URL + "/image/whitePlane_a.png",
                    iconSize: [25, 25],
                    iconAnchor: [15, 15],
                    tooltipAnchor: [20, 0],
                });
            }
        }
        return my_icon;
    } else {
        var other_icon = L.icon({
            iconUrl: process.env.BASE_URL + "/image/searchPlane_a.png",
            iconSize: [20, 20],
            iconAnchor: [15, 15],
            tooltipAnchor: [20, 0],
        });
        return other_icon
    }


}


/**
 * 初始化飞机图标  灰飞机
 * @param aircraftInfo
 */
OurMap.prototype.initMarkerIcon = function(aircraftInfo) {

    if (aircraftInfo.partOfGeneralCompany) {
        // 通航
        let my_icon;
        if (aircraftInfo.aircraftcategory === "AIRCRAFT") {
            //固定翼
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/whitePlane_f.png",
                iconSize: [25, 25],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else if (aircraftInfo.aircraftcategory === "ROTORCRAFT") {
            //旋翼机
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/whitePlane_f.png",
                iconSize: [25, 25],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else if (aircraftInfo.aircraftcategory === "HELICOPTER") {
            //直升机
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/helicopter0_f.png",
                iconSize: [35, 35],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else if (aircraftInfo.aircraftcategory === "FREE_BALLOON") {
            //气球
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/balloon_f.png",
                iconSize: [25, 25],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else if (aircraftInfo.aircraftcategory === "UNMANNEDAV") {
            //无人机
            my_icon = L.icon({
                iconUrl: process.env.BASE_URL + "/image/UAV1_f.png",
                iconSize: [25, 25],
                iconAnchor: [15, 15],
                tooltipAnchor: [20, 0],
            });
        } else {
            if (aircraftInfo.icon === 'helicopter') {
                my_icon = L.icon({
                    iconUrl: process.env.BASE_URL + "/image/helicopter0_f.png",
                    iconSize: [30, 30],
                    iconAnchor: [15, 15],
                    tooltipAnchor: [20, 0],
                });
            } else {
                my_icon = L.icon({
                    iconUrl: process.env.BASE_URL + "/image/whitePlane_f.png",
                    iconSize: [20, 20],
                    iconAnchor: [15, 15],
                    tooltipAnchor: [20, 0],
                });
            }
        }
        return my_icon;
    } else {
        var other_icon = L.icon({
            iconUrl: process.env.BASE_URL + '/image/normalPlane.png',
            iconSize: [20, 20],
            iconAnchor: [15, 15],
            tooltipAnchor: [20, 0],
        });
        return other_icon
    }
}


/**
 * 通过icao获得飞机点
 * @param icao
 * @returns
 */
OurMap.prototype.getOneMarkerByIcao = function(icao) {
    var ourMap = this;

    for (var i = 0; i < ourMap.markers.length; i++) {
        var marker = ourMap.markers[i];
        var markerIcao = marker.icao;
        if (markerIcao == icao) {
            return marker;
        }
    }
    return false;
}

/**
 * 通过icao获得标牌
 * @param icao
 * @param type
 * @returns
 */
OurMap.prototype.getOneLabelByIcao = function(icao, type) {
    var ourMap = this;

    let arr = [];

    ourMap.Labels.forEach((item) => {
        if (item.type === type) {
            arr.push(item);
        }
    });

    for (var i = 0; i < arr.length; i++) {
        var Label = arr[i];
        var LabelIcao = Label.icao;
        if (LabelIcao == icao) {
            return Label;
        }
    }
    return false;
}


/**
 * 通过所有标牌
 * @param icao
 * @param type
 * @returns
 */
OurMap.prototype.getAllLabel = function(type) {
    var ourMap = this;

    let arr = [];

    ourMap.Labels.forEach((item) => {
        if (item.type === type) {
            arr.push(item);
        }
    });

    return arr;
}


/**
 * 删除地图上的飞机
 * @returns
 */
OurMap.prototype.removeOldMarkerByIcao = function(icao) {
    var ourMap = this;
    let marker = ourMap.getOneMarkerByIcao(icao);
    if (marker) {
        ourMap.adsbMap.iconGroup.removeLayer(
            marker
        );
    }

    ourMap.markers.forEach((item, index) => {
        if (item.icao === icao) {
            ourMap.markers.splice(index, 1);
        }
    });

}


/**
 * 删除地图上的标牌
 * @returns
 */
OurMap.prototype.removeOldLabelByIcao = function(icao) {
    var ourMap = this;
    let polyline = ourMap.getOneLabelByIcao(icao, 1);
    let marketDiv = ourMap.getOneLabelByIcao(icao, 2);
    if (polyline) {
        ourMap.adsbMap.iconGroup.removeLayer(
            polyline
        );
        ourMap.Labels.forEach((item, index) => {
            if (item.icao === icao) {
                if (item.type === 1) {
                    ourMap.Labels.splice(index, 1);
                }
            }
        });

    }
    if (marketDiv) {
        ourMap.adsbMap.iconGroup.removeLayer(
            marketDiv
        );
        ourMap.Labels.forEach((item, index) => {
            if (item.icao === icao) {
                if (item.type === 2) {
                    ourMap.Labels.splice(index, 1);
                }
            }
        });
    }

}


/**
 * 设置label
 * @param title
 */
OurMap.prototype.setLabelSn = function(title) {
    var ourMap = this;

    if (title) {
        ourMap.tagSn = true;
    } else {
        ourMap.tagSn = false;
    }

    let allMarketDiv = ourMap.getAllLabel(2);

    allMarketDiv.forEach((marketDiv) => {
        marketDiv._icon.innerHTML = ourMap.initLabelHtmlStr(marketDiv.aircraftInfo, marketDiv);
    })
}

/**
 * 设置label
 * @param title
 */
OurMap.prototype.setLabelHeight = function(title) {
    var ourMap = this;

    if (title) {
        ourMap.tagHeight = true;
    } else {
        ourMap.tagHeight = false;
    }
    let allMarketDiv = ourMap.getAllLabel(2);

    allMarketDiv.forEach((marketDiv) => {
        marketDiv._icon.innerHTML = ourMap.initLabelHtmlStr(marketDiv.aircraftInfo, marketDiv);
    })
}

/**
 * 设置label
 * @param title
 */
OurMap.prototype.setLabelSp = function(title) {
    var ourMap = this;

    if (title) {
        ourMap.tagSp = true;
    } else {
        ourMap.tagSp = false;
    }
    let allMarketDiv = ourMap.getAllLabel(2);

    allMarketDiv.forEach((marketDiv) => {
        marketDiv._icon.innerHTML = ourMap.initLabelHtmlStr(marketDiv.aircraftInfo, marketDiv);
    })
}

/**
 * 设置label
 * @param title
 */
OurMap.prototype.setLabelCompany = function(title) {
    var ourMap = this;

    if (title) {
        ourMap.tagCompany = true;
    } else {
        ourMap.tagCompany = false;
    }
    let allMarketDiv = ourMap.getAllLabel(2);

    allMarketDiv.forEach((marketDiv) => {
        marketDiv._icon.innerHTML = ourMap.initLabelHtmlStr(marketDiv.aircraftInfo, marketDiv);
    })
}

/**
 * 设置label
 * @param title
 */
OurMap.prototype.setLabelHeightChage = function(title) {
    var ourMap = this;

    if (title) {
        ourMap.tagHeightChage = true;
    } else {
        ourMap.tagHeightChage = false;
    }
    let allMarketDiv = ourMap.getAllLabel(2);

    allMarketDiv.forEach((marketDiv) => {
        marketDiv._icon.innerHTML = ourMap.initLabelHtmlStr(marketDiv.aircraftInfo, marketDiv);
    })
}


/**
 * 设置标牌信息
 * @param aircraftInfo
 * @param MarketDiv
 */
OurMap.prototype.initLabelHtmlStr = function(aircraftInfo, MarketDiv) {

    var ourMap = this;

    let baseHtmlStr = ``;
    let plusHtmlStr = ``;

    let callsign = aircraftInfo.callsign ? aircraftInfo.callsign : aircraftInfo.icao;
    let avGroundSpeed = aircraftInfo.airVelocityInfo.avGroundSpeed ?
        aircraftInfo.airVelocityInfo.avGroundSpeed :
        0;
    let alAltitude = aircraftInfo.airLocationInfo.alAltitude ?
        aircraftInfo.airLocationInfo.alAltitude :
        0;

    let geometricHeight = aircraftInfo.airLocationInfo.geometricHeight ?
        aircraftInfo.airLocationInfo.geometricHeight :
        0;

    let avBiasMagneticNorth = aircraftInfo.airVelocityInfo.avBiasMagneticNorth ?
        aircraftInfo.airVelocityInfo.avBiasMagneticNorth :
        0;
    let avVerticalSpeed = aircraftInfo.airVelocityInfo.avVerticalSpeed ?
        aircraftInfo.airVelocityInfo.avVerticalSpeed :
        0;
    let admessage = aircraftInfo.admessage ? aircraftInfo.admessage : aircraftInfo.company;


    baseHtmlStr += `<div style="display:${ourMap.tagSn ? '' : 'none'}">${callsign}&nbsp&nbsp&nbsp</div>`;

    baseHtmlStr += `<div style="display:${ourMap.tagHeight ? '' : 'none'}">gAl &nbsp${Math.floor(
        Number(geometricHeight) / 3.2808399
    )}  &nbsp&nbsp</div>`;

    baseHtmlStr += `<div style="display:${ourMap.tagSp ? '' : 'none'}">Sp&nbsp${Math.floor(
        avGroundSpeed * 1.852
    )}&nbsp&nbsp   </div>`;

    if (aircraftInfo.transpondercode) { baseHtmlStr += `<div>应答机：${aircraftInfo.transpondercode} </div>`; }


    plusHtmlStr += `<div style="display:${ourMap.tagSn ? '' : 'none'}">${callsign}&nbsp&nbsp&nbsp</div>`;

    plusHtmlStr += `<div style="display:${ourMap.tagHeight ? '' : 'none'}">gAl &nbsp${Math.floor(
        Number(geometricHeight) / 3.2808399
    )}  &nbsp&nbsp Al &nbsp${Math.floor(
        Number(alAltitude) / 3.2808399
    )}</div>`;
    plusHtmlStr += `<div> <span style="display:${ourMap.tagSp ? '' : 'none'}">Sp&nbsp${Math.floor(
        avGroundSpeed * 1.852
    )} </span> &nbsp&nbsp  <span style="display:${ourMap.tagHeightChage ? '' : 'none'}"> ${aircraftInfo.heightchange > 0
        ?
        '↑Vs &nbsp&nbsp' + Math.floor(
            Number(aircraftInfo.heightchange) / 3.2808399)
        :
        '↓Vs &nbsp&nbsp' + Math.floor(
            Number(aircraftInfo.heightchange) / 3.2808399)} </span> </div>`;
    if (aircraftInfo.transpondercode) { plusHtmlStr += `<div>应答机：${aircraftInfo.transpondercode} </div>`; }

    plusHtmlStr += `<div>${avBiasMagneticNorth}°</div>`;

    plusHtmlStr += `<div>机型:${aircraftInfo.devicetype}</div>`;

    if (aircraftInfo.partOfGeneralCompany === true) {
        if (admessage) {
            plusHtmlStr += `<div style="display:${ourMap.tagCompany ? '' : 'none'}">${admessage}</div>`;
        } else {
            plusHtmlStr += `<div style="display:${ourMap.tagCompany ? '' : 'none'}">${'无'}</div>`;
        }
    }

    let marker = ourMap.getOneMarkerByIcao(aircraftInfo.icao);
    let polyline = ourMap.getOneLabelByIcao(aircraftInfo.icao, 1);
    let marketDiv = ourMap.getOneLabelByIcao(aircraftInfo.icao, 2);

    // 告警
    let Html = "";
    if (marker.alarmShow) {

        if (marker.alarmZoneStr) {
            Html += `<div style="color:#ff2400;font-size:15px">${'告警：' + marker.alarmZoneStr} </div>`;
        } else
        if (marker.alarmDistanceStr) {
            Html += `<div style="color:#ff2400;font-size:15px">${'告警：' + marker.alarmDistanceStr} </div>`;
        } else
        if (marker.alarmDisappearStr) {
            Html += `<div style="color:#ff2400;font-size:15px">${'告警：' + marker.alarmDisappearStr} </div>`;
        } else
        if (marker.alarmYawStr) {
            Html += `<div style="color:#ff2400;font-size:15px">${'告警：' + marker.alarmYawStr} </div>`;
        }


        // if (MarketDiv.divClick) {
        //     plusHtmlStr += Html;
        // } else {
        //     baseHtmlStr += Html;
        // }
    } else {
        marker.setOpacity(1);

        if (polyline) {
            polyline.setStyle({
                opacity: 1,
                fillOpacity: 1,
            });
        }
        if (marketDiv) {
            marketDiv.setOpacity(1);
        }

        // Html += `<div style="font-size:16px">${'告警：无告警'} </div>`;
        // plusHtmlStr += Html;
    }

    if (MarketDiv.divClick) {
        return plusHtmlStr;
    } else {
        return baseHtmlStr;
    }
};


/**
 * 绘制预测线
 * 
 */
OurMap.prototype.createPredictLine = function(aircraftInfo) {
    var ourMap = this;
    var triangleCoords = [];
    var craftLine = L.latLng(aircraftInfo.correctLatitude, aircraftInfo.correctLongitude);
    var predictLaAndLo = aircraftInfo.getPredictLine();
    var predictCraftLine = L.latLng(predictLaAndLo.la, predictLaAndLo.lo);
    triangleCoords.push(craftLine);
    triangleCoords.push(predictCraftLine);

    // 区域绘制
    var poly = L.polyline(triangleCoords, {
        color: '#9af8f8',
        weight: 2,
        dashArray: [10, 10],
        pane: 'dash'
    });
    poly.icao = aircraftInfo.icao;
    poly.addTo(map);
    ourMap.predictLinePolys.push(poly);
}

OurMap.prototype.getOnePredictLinePolyIndex = function(aircraftInfo) {
    var ourMap = this;

    for (var i = 0; i < ourMap.predictLinePolys.length; i++) {
        var poly = ourMap.predictLinePolys[i];
        var icao = poly.icao;
        if (icao == aircraftInfo.icao) {
            return i;
        }
    }
    return -1;
}

/**
 * 绘制轨迹线
 * @param aircraftInfo
 * @returns
 */
OurMap.prototype.createLocusLine = function(icao, data) {
    var ourMap = this;
    var hotlineLayer = new L.Polyline(data, {
        color: "#c3d3ea",
        weight: 1,
    });
    hotlineLayer.addTo(ourMap.adsbMap.locusGroup);
    hotlineLayer.icao = icao;
    return hotlineLayer;
}

OurMap.prototype.getOneLocusLinePolyIndex = function(aircraftInfo) {
    var ourMap = this;

    for (var i = 0; i < ourMap.locusLinePolys.length; i++) {
        var poly = ourMap.locusLinePolys[i];
        var icao = poly.icao;
        if (icao == aircraftInfo.icao) {
            return i;
        }
    }
    return -1;
}



/**
 * 绘制尾迹线
 * @param aircraftInfo
 * @returns
 */
OurMap.prototype.createWakeLine = function(icao, data) {
    var ourMap = this;
    var hotlineLayer = new L.Polyline(data, {
        color: "#c3d3ea",
        weight: 1,
    });
    hotlineLayer.addTo(ourMap.adsbMap.wakeGroup);
    hotlineLayer.icao = icao;
    return hotlineLayer;
}

OurMap.prototype.getOneWakeLinePolyIndex = function(aircraftInfo) {
    var ourMap = this;

    for (var i = 0; i < ourMap.wakeLinePolys.length; i++) {
        var poly = ourMap.wakeLinePolys[i];
        var icao = poly.icao;
        if (icao == aircraftInfo.icao) {
            return i;
        }
    }
    return -1;
}


/**
 * 绘制关注框
 * @param aircraftInfo
 * @returns
 */
OurMap.prototype.createFollow = function(icao, latlng) {
    var ourMap = this;
    let layer = L.circle(latlng, {
        radius: 1000,
        color: '#92f892',
        fillOpacity: 0,
    });
    layer.addTo(ourMap.adsbMap.followGroup);
    layer.icao = icao;
    return layer;
}



OurMap.prototype.getOneFollowPolyIndex = function(aircraftInfo) {
    var ourMap = this;

    for (var i = 0; i < ourMap.followPolys.length; i++) {
        var poly = ourMap.followPolys[i];
        var icao = poly.icao;
        if (icao == aircraftInfo.icao) {
            return i;
        }
    }
    return -1;
}



//测距画线
/**
 * 画折线
 */
OurMap.prototype.drawRangePolyline = function(points) {
    var ourMap = this;

    var color = '#24ff00';
    // 定义路径
    var triangleCoords = [];

    triangleCoords[0] = [points[0].la, points[0].lo];
    triangleCoords[1] = [points[1].la, points[1].lo];

    // 区域折线
    var bermudaTriangle = L.polyline(triangleCoords, {
        //设置线条颜色
        color: color,
        //线条粗细
        weight: 1,
    });

    if (ourMap.calculatDistanceLine != null) {
        ourMap.calculatDistanceLine.removeFrom(map);
    }

    bermudaTriangle.addTo(map);
    ourMap.calculatDistanceLine = bermudaTriangle;
}


//添加测距线
/**
 */
OurMap.prototype.addRangePolyline = function(points) {

    var ourMap = this;
    if (!ourMap.calculatDistanceLine) {
        return
    }

    if (points[0].hasIcao || points[1].hasIcao) {
        ourMap.calculatDistanceLine.hasIcao = true;
        if (points[0].hasIcao) {
            ourMap.calculatDistanceLine.icao0 = points[0].icao;
        } else {
            ourMap.calculatDistanceLine.latlngArr = [points[0].la, points[0].lo];
        }
        if (points[1].hasIcao) {
            ourMap.calculatDistanceLine.icao1 = points[1].icao;
        } else {
            ourMap.calculatDistanceLine.latlngArr = [points[1].la, points[1].lo];
        }
    } else {
        ourMap.calculatDistanceLine.hasIcao = false;
    }

    ourMap.calculatDistanceLines.push(ourMap.calculatDistanceLine);
    ourMap.calculatDistanceLine = null;
}


/**
 * 重绘测距线
 */
OurMap.prototype.redrawRangePolyline = function() {
    var ourMap = this;


    ourMap.calculatDistanceLines.forEach((calculatDistanceLine) => {

        if (!calculatDistanceLine.hasIcao) {
            return
        }

        let icao0 = calculatDistanceLine.icao0 || calculatDistanceLine.icao1;
        let icao1;
        if (calculatDistanceLine.icao0) {
            icao1 = calculatDistanceLine.icao1;
        } else {
            icao1 = calculatDistanceLine.icao0;
        }

        var aircraftInfo0 = ourMap.aircraftInfos[ourMap.$vm.getAircraftInfoIndex(icao0)];

        var aircraftInfo1;
        let LatLng;
        if (icao0 && icao1) { //都有
            aircraftInfo1 = ourMap.aircraftInfos[ourMap.$vm.getAircraftInfoIndex(icao1)];
            LatLng = [
                [aircraftInfo0.alLatitude, aircraftInfo0.alLongitude],
                [aircraftInfo1.alLatitude, aircraftInfo1.alLongitude]
            ]

        } else { //有一个
            LatLng = [
                [aircraftInfo0.alLatitude, aircraftInfo0.alLongitude],
                [calculatDistanceLine.latlngArr[0], calculatDistanceLine.latlngArr[1]]
            ]

        }
        calculatDistanceLine.setLatLngs(LatLng);
    })
}

/**
 *添加距离与角度
 */
OurMap.prototype.showDistance = function(points) {
    var ourMap = this;

    var distance = Math.ceil(map.distance(L.latLng(points[0].la, points[0].lo), L.latLng(points[1].la, points[1].lo)));

    var la = (points[0].la * 1 + points[1].la * 1) / 2;
    var lo = (points[0].lo * 1 + points[1].lo * 1) / 2;
    var monitoringZoneNameLocation = [la, lo];

    let Angle = ourMap.calcAngle(points);

    var circleMarker = L.circleMarker(monitoringZoneNameLocation, {
        radius: 0,
        opacity: 0,
    }).bindTooltip(`${Number(distance / 1000).toFixed(2)}km    ${Angle}°`, { permanent: true, offset: [0, 0], className: 'DistanceTooltip' });

    circleMarker.addTo(map);

    ourMap.calculatDistanceMark = circleMarker;

    //设置点属性
    if (points[0].hasIcao || points[1].hasIcao) {
        ourMap.calculatDistanceMark.hasIcao = true;
        if (points[0].hasIcao) {
            ourMap.calculatDistanceMark.icao0 = points[0].icao;
        } else {
            ourMap.calculatDistanceMark.latlngArr = [points[0].la, points[0].lo];
        }

        if (points[1].hasIcao) {
            ourMap.calculatDistanceMark.icao1 = points[1].icao;
        } else {
            ourMap.calculatDistanceMark.latlngArr = [points[1].la, points[1].lo];
        }
    } else {
        ourMap.calculatDistanceMark.hasIcao = false;
    }

    ourMap.calculatDistanceMarks.push(ourMap.calculatDistanceMark);
    ourMap.calculatDistanceMark = null;
}

OurMap.prototype.calcAngle = function(points) {

    // 通过map 将起始点终止点经纬度坐标转容器坐标
    const pStart = map.latLngToContainerPoint([points[0].la, points[0].lo]);
    const pEnd = map.latLngToContainerPoint([points[1].la, points[1].lo]);

    // 计算容器坐标点位
    const diffX = pStart.x - pEnd.x;
    const diffY = -(pStart.y - pEnd.y);
    // 通过坐标计算角度 逆时针角度
    let angle = 360 * Math.atan2(diffY, diffX) / (2 * Math.PI) + 90;
    // 将逆时针角度转换成正角度
    angle = angle < 0 ? -angle : 360 - angle;
    return angle.toFixed(2);
}

/**
 *更新距离
 */
OurMap.prototype.updateDistance = function() {
    var ourMap = this;

    ourMap.calculatDistanceMarks.forEach((calculatDistanceMark, index) => {

        if (!calculatDistanceMark.hasIcao) {
            return
        }

        let icao0 = calculatDistanceMark.icao0 || calculatDistanceMark.icao1;
        let icao1;
        if (calculatDistanceMark.icao0) {
            icao1 = calculatDistanceMark.icao1;
        } else {
            icao1 = calculatDistanceMark.icao0;
        }

        var aircraftInfo0 = ourMap.aircraftInfos[ourMap.$vm.getAircraftInfoIndex(icao0)];

        var aircraftInfo1;
        let LatLng;
        if (icao0 && icao1) {
            aircraftInfo1 = ourMap.aircraftInfos[ourMap.$vm.getAircraftInfoIndex(icao1)];
            LatLng = [
                [aircraftInfo0.alLatitude, aircraftInfo0.alLongitude],
                [aircraftInfo1.alLatitude, aircraftInfo1.alLongitude]
            ]
        } else {
            LatLng = [
                [aircraftInfo0.alLatitude, aircraftInfo0.alLongitude],
                [calculatDistanceMark.latlngArr[0], calculatDistanceMark.latlngArr[1]]
            ]
        }
        let Angle
        if (!calculatDistanceMark.icao0) {
            Angle = ourMap.calcAngle([{
                    la: LatLng[1][0],
                    lo: LatLng[1][1]
                },
                {
                    la: LatLng[0][0],
                    lo: LatLng[0][1]
                }

            ]);
        } else {
            Angle = ourMap.calcAngle([{
                    la: LatLng[0][0],
                    lo: LatLng[0][1]
                }, {
                    la: LatLng[1][0],
                    lo: LatLng[1][1]
                }

            ]);
        }


        var distance = Math.ceil(map.distance(LatLng[0], LatLng[1]));
        var la = ((LatLng[0][0] - 0) + (LatLng[1][0] - 0)) / 2;
        var lo = ((LatLng[0][1] - 0) + (LatLng[1][1] - 0)) / 2;
        var monitoringZoneNameLocation = [la, lo];


        calculatDistanceMark.setLatLng(monitoringZoneNameLocation);
        calculatDistanceMark.setTooltipContent(`${Number(distance / 1000).toFixed(2)}km    ${Angle}°`);

    })
}

/**
 * 重置测距点
 *  */
OurMap.prototype.redrawMarkerPoint = function() {
    var ourMap = this;

    ourMap.MarkerPoints.forEach((MarkerPoint) => {
        if (MarkerPoint.hasIcao) {
            var aircraftInfo = ourMap.aircraftInfos[ourMap.$vm.getAircraftInfoIndex(MarkerPoint.icao)];


            MarkerPoint.setLatLng([aircraftInfo.alLatitude, aircraftInfo.alLongitude]);
        }
    });
}


OurMap.prototype.getOneCalculatDistanceLineIndex = function() {
    var ourMap = this;

    for (var i = 0; i < ourMap.calculatDistanceLines.length; i++) {
        var poly = ourMap.calculatDistanceLines[i];
        if (poly.hasIcao) {
            return i;
        }
    }
    return -1;
}

//删除测距相关
OurMap.prototype.hideRangePolyline = function() {

    var ourMap = this;
    ourMap.calculatDistanceLines.forEach((calculatDistanceLine) => {
        calculatDistanceLine.removeFrom(map);
    })

    ourMap.calculatDistanceLines = [];
}

OurMap.prototype.hideDistance = function() {

    var ourMap = this;
    ourMap.calculatDistanceMarks.forEach((calculatDistanceMark) => {
        calculatDistanceMark.removeFrom(map);
    })

    ourMap.calculatDistanceMarks = [];
}

OurMap.prototype.hideMarkerPoint = function() {

    var ourMap = this;
    ourMap.MarkerPoints.forEach((MarkerPoint) => {
        MarkerPoint.removeFrom(map);
    })

    ourMap.MarkerPoints = [];
}


/**
 * 清除所有
 */
OurMap.prototype.hideAllLocus = function() {
    var ourMap = this;

    this.locusLinePolys.forEach((locusLinePoly, index) => {
        ourMap.adsbMap.locusGroup.removeLayer(locusLinePoly);
        ourMap.locusLinePolys.splice(index, 1);
    });

}



/**
 * 清除所有
 */
OurMap.prototype.hideAllWake = function() {
    var ourMap = this;
    this.wakeLinePolys.forEach((wakeLinePoly, index) => {
        ourMap.adsbMap.wakeGroup.removeLayer(wakeLinePoly);
        ourMap.wakeLinePolys.splice(index, 1);
    });
}



/**
 * 清除所有
 */
OurMap.prototype.hideAllPredictLine = function() {
    var ourMap = this;
    this.predictLinePolys.forEach((predictLinePoly, index) => {
        map.removeLayer(predictLinePoly);
        ourMap.predictLinePolys.splice(index, 1);
    });
}

/**
 * 清除所有
 */
OurMap.prototype.hideAllFollow = function() {
    var ourMap = this;
    // this.aircraftInfos.forEach((aircraftInfo) => {
    //     if (aircraftInfo.isFollow) {
    //         aircraftInfo.hideFollow();
    //     }
    // })

}